export const arraysToObjects = <R = Record<string, any>>(object: Record<string, any>): R => {
  const result: Record<string, any> = {};

  for (const key in object) {
    const value = object[key];

    if (Array.isArray(value)) {
      result[key] = value.reduce((acc, item) => ({ ...acc, [item]: true }), {});
    } else {
      result[key] = value;
    }
  }

  return result as R;
};
